<template>
  <div class="page-wrapper">
    <v-col cols="12" lg="10" md="7">
      <v-form>
        <v-card class="card-shadow bg-secondary">
          <ListaOperadora />
        </v-card>
      </v-form>
    </v-col>
  </div>
</template>



<script>
import ListaOperadora from "../Components/Listagens/ListaOperadora.vue";
export default {
  name: "ListReserve",
  components: {
    ListaOperadora,
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.page-wrapper {
  display: flex;
  justify-content: center;
}
</style>
